import React, {useState} from 'react';
import DotsLoading from 'components/loadings/dotsLoading';
import Modal from 'components/modal';
import SendReplyMSG from 'components/modal/sendReplyMSG';
import useGetPrepaymentSuggestion from '../../../RregisteredOffersPrepayment/hooks/useGetPrepaymentSuggestion';
import ChoosePrepaymentItem from './ChooseprepaymentItem';
import useDeleteAd from 'modules/myAdvertisment/myAdvertisment/deleteModal/deleteForm/hooks/useDeleteAd';
import useSaledPost from 'modules/myAdvertisment/hooks/useSaledPost';
interface ChooseprepaymentProps {
  postTypes: string;
  chosedSugestionUser: IChosedSugestionUser;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}
const Chooseprepayment = ({
  chosedSugestionUser,
  postTypes,
  setChosedSugestionUser,
}: ChooseprepaymentProps) => {
  const [isSendMSGOpen, setIsSendMSGOpen] = useState<boolean>(false);

  const {data, isLoading} = useGetPrepaymentSuggestion(
    chosedSugestionUser.guid ? chosedSugestionUser.guid : '',
  );
  const {mutate} = useDeleteAd({
    action: () =>
      setChosedSugestionUser({
        guid: null,
        isDelete: false,
        isOpenModal: false,
        profile: null,
        type: null,
      }),
  });

  const {mutateSaled} = useSaledPost({
    action: () =>
      chosedSugestionUser.isDelete &&
      mutate({
        guid: chosedSugestionUser.guid ? chosedSugestionUser.guid : '',
        delete_reason: 'successful',
        type: 'post',
      }),
  });

  const chossingNoneWinner = () => {
    mutateSaled({
      guid: chosedSugestionUser.guid ? chosedSugestionUser.guid : '',
    });
  };
  return (
    <>
      <div className="w-full">
        <div className="flex w-full items-center justify-between py-3 text-green-1 text-[16px]">
          <div className="pr-3 w-[20%] flex items-center justify-center">
            <button
              className="border-[1px] border-primary bg-white text-primary rounded-lg p-2"
              onClick={() => chossingNoneWinner()}
            >
              هیچکدام
            </button>
          </div>
          <div className="text-gray-6 w-[30%] flex items-center justify-center">
            مقدار محصول
          </div>
          <div className="text-gray-6 w-[30%]  flex items-center justify-center">
            قیمت
            <span className="text-[12px]">(هر کیلو)</span>
          </div>

          <div className="w-[10%] flex items-center justify-center" />
        </div>
      </div>
      <div className="flex flex-col w-full  [&>*:nth-child(odd)]:bg-light-gray overflow-y-auto max-h-[60vh] [&>*:nth-child(even)]:bg-white">
        {isLoading ? (
          <DotsLoading />
        ) : (
          data
            ?.map((item, index) => (
              <ChoosePrepaymentItem
                key={index}
                item={item}
                chosedSugestionUser={chosedSugestionUser}
                isSendMSGOpen={isSendMSGOpen}
                setChosedSugestionUser={setChosedSugestionUser}
                setIsSendMSGOpen={setIsSendMSGOpen}
              />
            ))
            .reverse()
        )}
      </div>
      <Modal
        isOpen={isSendMSGOpen}
        setIsOpen={value => {
          setIsSendMSGOpen(value);
          setChosedSugestionUser({
            ...chosedSugestionUser,
            profile: null,
          });
        }}
      >
        <SendReplyMSG
          post={chosedSugestionUser.guid ? chosedSugestionUser.guid : ''}
          post_type={postTypes}
          profile_type={
            chosedSugestionUser.type ? chosedSugestionUser.type : ''
          }
          setIsOpen={value => {
            setIsSendMSGOpen(value);
            setChosedSugestionUser({
              ...chosedSugestionUser,
              profile: null,
            });
          }}
        />
      </Modal>
    </>
  );
};

export default Chooseprepayment;
